import React from 'react';
import { Check, X } from 'lucide-react';
import { PasswordRequirement } from '../utils/validation';

interface PasswordRequirementsProps {
  requirements: PasswordRequirement[];
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ requirements }) => {
  return (
    <div className="space-y-1.5 p-3 bg-gray-50 rounded-lg border border-gray-200">
      <p className="text-xs font-medium text-gray-700 mb-2">Password must contain:</p>
      {requirements.map((req, index) => (
        <div key={index} className="flex items-center gap-2">
          {req.met ? (
            <Check className="h-4 w-4 text-green-600 flex-shrink-0" />
          ) : (
            <X className="h-4 w-4 text-gray-400 flex-shrink-0" />
          )}
          <span
            className={`text-xs ${
              req.met ? 'text-green-700 font-medium' : 'text-gray-600'
            }`}
          >
            {req.label}
          </span>
        </div>
      ))}
    </div>
  );
};
